import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import authStore from './auth-store';
import ElementUI from 'element-ui';
import AuthComponent from './components/Auth.vue';
import LoginComponent from './components/Login.vue';
import RegisterComponent from './components/Register.vue';
import RecoverComponent from './components/Recover.vue';
import OrderUserInfoComponent from './components/OrderUserInfo.vue';
import notification_header from './components/EshopNotificationsHeader';
import notification_footer from './components/EshopNotificationsFooter';

Vue.use(Vuex);
Vue.use(ElementUI);
Vue.component('auth', AuthComponent);
Vue.component('login', LoginComponent);
Vue.component('register', RegisterComponent);
Vue.component('recover', RecoverComponent);
Vue.component('order-user-info', OrderUserInfoComponent);

Vue.component('message', {
  template: `
    <div>
      <div style="padding-bottom: 12px">
        <p>{{ message }}</p>
        <p><a @click="goBack">{{ backLabel }}</a></p>
      </div>
    </div>
  `,
  methods: {
    goBack() {
      this.$store.commit('auth/loadComponent', 'login');
    }
  },
  computed: {
    message() {
      return this.$store.state.auth.message;
    },
    backLabel() {
      return $r.auth_back;
    },
  }
});

const store = new Vuex.Store({
  state: {
    leftComponent: 'auth',
    orderUserForm: {},
    orderUserFormErrors: {},
    orderComment: '',
    orderReady: false,
    g_recaptcha_response : null
  },
  getters: {
    getFormData(state) {
      let form = state.orderUserForm;
      form.comment = state.orderComment;
      form.g_recaptcha_response = state.g_recaptcha_response;
      return form;
    },
    getRightHeader(state, getters) {
      return state.orderReady ? $r.cart_header_order_details : $r.cart_header_non_auth;
    }
  },
  mutations: {
    setLeftComponent(state, component) {
      state.leftComponent = component;
    },
    setOrderUserForm(state, data) {
      state.orderUserForm = data;
    },
    setOrderComment(state, comment) {
      state.orderComment = comment;
    },
    setOrderFormErrors(state, errors) {
      state.orderUserFormErrors = errors;
    },
    setOrderReady(state, status) {
      state.orderReady = status;
    },
    setRecaptcha(state, recaptcha_){
      state.g_recaptcha_response = recaptcha_;
    }
  },
  actions: {
  },
  modules: {
    auth: authStore,
  }
});

window.cart = new Vue({
  el: '#cart',
  store,
  components : {notification_header, notification_footer},
  data: {
    tableLoading: true,
    tableData: [],
    showOrderAction: true,
    leftHeader: null,
    leftComponent: null,
    leftViewMessage: null,
    user: {},
    showOrdering: false,
    noRegForm: {},
    noRegFormRules: {},
    noRegFormErrors: {},
    orderLoading: false,
    orderComplete: false,
    orderCompleteMsg: window.$r.cart_msg_submitted_txt
  },
  watch: {
    '$store.state.auth.authorized': function() {
      this.renderRecaptcha(100);
    }
  },
  methods: {

    cartAction(action_, index_, id_, e_){
      e_.preventDefault();

      let row = this.tableData[index_];
      var current = row.quantity;
      var stock= row.stock;
      //var stock_type = row.WebLocationType;
      var pcs_in_pack = row.pcs_in_pack;
      var new_qty;
      var alert = false;

      switch (action_)
      {
        case 'add':
          new_qty = current + (1 * pcs_in_pack);
          alert = new_qty > stock;
        break;
        case 'sub':
          new_qty = current - (1 * pcs_in_pack);
        break;
      }

      if (!alert) {
        if (new_qty == 0)
          this.removeItem(index_, id_);
        else {
          var cart_items = {};
          for (var i=0; i<this.tableData.length; i++)
          {
            cart_items[this.tableData[i].id] = this.tableData[i].quantity;
          }
          cart_items[id_] = (row.WebLocationType == 'MT' ? new_qty : new_qty / pcs_in_pack);
          axios.post('/' + window.lang + '/shop/addcart', {cart_items})
              .then((response) => {
                let data = response.data;
                switch (data.status) {
                  case 1: // Veiksmīga pievienošana
                      row.quantity = new_qty;
                      row.price_total_raw = row.price_one_raw * (row.quantity / pcs_in_pack);
                      row.price_total = '€ ' + (row.price_one_raw * row.quantity).toFixed(2);
                  break;
                  case 2: // Grozā nevar visu ielikt, jo nepietiek atlikumu (netiek ielikts nekas grozā)
                    this.$toasted.global.warning(data.msg);
                  break;
                }
              })
              .catch(err => {
                console.error(err);
              });
        }
      }
      else
      {
        this.$toasted.global.warning($r.shop_onlyavailable_pt1 + ' ' + (current) + ' ' + $r.shop_onlyavailable_pt2);
      }

      // switch (row.WebLocationType)
      // {
      //   case 'VT':
      //
      //     alert = ();
      //   break;
      //   case 'MT':
      //
      //   break;
      // }
    },

    removeItem (index, id) {

      let row = this.tableData[index];
      row.loading = true;
      document.querySelector('[data-remove-button="'+index+'"]').blur();
      this.$set(this.tableData, index, row);
      axios.post('/' + window.lang + '/shop/cart-data', { id })
        .then(res => {
          if (res.data.status) {
            this.tableData.splice(index, 1);
            this.$toasted.global.success($r.msg_cart_removeitem);
            // this.$notify({
            //   message: $r.msg_cart_removeitem,
            //   duration: 2500,
            //   type: 'success'
            // });
          }
        })
        .catch(err => {
          console.err(err);
          row.loading = false;
          this.$set(this.tableData, index, row);
        });
    },
    setRegisterView() {
    },
    orderNoRegistration() {
      this.$store.commit('setLeftComponent', 'order-user-info');
      this.$store.commit('setOrderReady', true);
      this.showOrdering = true;

      // recaptcha only if secret
      this.renderRecaptcha(100);
    },

    removeCartItemByOriginalRecId(orig_rec_id_){
      for (var i=0; i<this.tableData.length; i++)
      {
        if (orig_rec_id_ == this.tableData[i].OriginalRecId)
        {
          this.tableData.splice(i, 1);
        }
      }
    },

    prepareKeyObject(data_, key_, multi_){
      var data_objkeys = {};
      for (var i in data_)
      {
        if (typeof multi_ == 'undefined' || !multi_)
          data_objkeys[data_[i][key_]] = data_[i];
        else
        {
          if (!data_objkeys.hasOwnProperty(data_[i][key_]))
          {
            data_objkeys[data_[i][key_]] = [];
          }
          data_objkeys[data_[i][key_]].push(data_[i]);
        }
      }
      return data_objkeys;
    },

    updateCartItemByOriginalRecId(orig_rec_id_, qty_){
      for (var i=0; i<this.tableData.length; i++)
      {
        if (orig_rec_id_ == this.tableData[i].OriginalRecId)
        {
          this.tableData[i].quantity = qty_;
        }
      }
    },

    order() {
      var $this = this;

      this.orderLoading = true;
      axios.post('/' + window.lang + '/shop/order', this.$store.getters.getFormData)
        .then(response => {
          if (response.data.status) {
            this.orderCompleteMsg = (response.data.hasOwnProperty('code') ? window.$r.cart_msg_email_error + '<br>': '') + this.orderCompleteMsg.replace('%order%', response.data.id);
            this.tableData = [];
            this.orderComplete = true;
            this.$nextTick(() => {
              window.scrollTo(0, 100);
            });
          }
          else {
            if (response.data.hasOwnProperty('code') && response.data.code == 1)
            {
              var tabledata = $this.prepareKeyObject($this.tableData, 'OriginalRecId', false);
              var msg = '';
              var qty_available;
              for (var origrecid in response.data.data)
              {
                qty_available = response.data.data[origrecid];
                if (tabledata.hasOwnProperty(origrecid))
                {
                  msg += tabledata[origrecid].title+ ' - <b>' + qty_available + '</b><br>';
                }
                if (qty_available == 0)
                  $this.removeCartItemByOriginalRecId(origrecid);
                else
                  $this.updateCartItemByOriginalRecId(origrecid, qty_available);
              }
              this.$alert(response.data.message + msg, response.data.title, { confirmButtonText: 'OK', dangerouslyUseHTMLString : true , customClass : 'alert-box-wider'});
            }
            else
              this.$alert(response.data.message, 'Kļūda veicot pasūtījumu', { confirmButtonText: 'OK' });
          }
        })
        .catch(error => {
          console.log(error);
          let e = {};
          _.forEach(error.response.data.errors, (errArray, key) => {
            e[key] = errArray[0];
          });
          this.$store.commit('setOrderFormErrors', e);
        })
        .then(() => {
          this.orderLoading = false;
        });
    },
    renderRecaptcha (timeout_){
      var $this = this;
      if (!window.userData.env && window.userData.recaptcha.enabled == 1) {
        setTimeout(function () {
          grecaptcha.render('grecaptcha', {
            'sitekey': window.userData.recaptcha.site_key,
            'theme': 'light',
            'callback' : function (g_recaptcha_response_){
              $this.$store.commit('setRecaptcha', g_recaptcha_response_);
            },
          });
        }, timeout_)
      }
    }
  },
  mounted() {
    var $this = this;
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == 'auth/setUserData') {
        if (mutation.payload.id) {
          this.$store.commit('setLeftComponent', 'order-user-info');
          this.$store.commit('setOrderUserForm', mutation.payload);
          this.$store.commit('setOrderReady', true);
          this.showOrdering = true;
        }
      }
    });
    this.$store.commit('auth/setUserData', window.userData);
    axios.get('/' + window.lang + '/shop/cart-data')
      .then(res => {
        this.tableData = _.map(res.data, function (item) {
          let priceOne = item.price_one;
          item.price_one = '€ ' + priceOne.toFixed(2);
          item.price_one_raw = priceOne.toFixed(2);
          item.price_total_raw = priceOne.toFixed(2) * item.quantity;
          item.price_total = '€ ' + (priceOne.toFixed(2) * item.quantity * item.pcs_in_pack).toFixed(2);
          item.thickness = item.thickness == 0 ? '' : item.thickness;
          item.length = item.length == 0 ? '' : item.length;
          item.width = item.width == 0 ? '' : item.width;
          item.quantity = item.quantity * item.pcs_in_pack;
          let totalm3 = item.thickness * item.length * item.width * 0.000000001 * item.quantity;
          item.totalm3 = totalm3 == 0 ? '' : totalm3.toFixed(2);
          return item;
        });
      })
      .catch(err => {
        this.$toasted.global.error($r.cart_err_datareq);
        // this.$notify({
        //   message: $r.cart_err_datareq,
        //   duration: 2500,
        //   type: 'error',
        // });
        console.error(err);
      })
      .then(() => {
        if (this.showOrdering) {
          $this.renderRecaptcha(100);
        }

        this.tableLoading = false;
        if (isMobile()) {
          var fakeScroll = document.createElement('div');
          fakeScroll.id = 'fake-scroll';
          fakeScroll.style = 'overflow-x: auto;';
          var fakeScrollChild = document.createElement('div');
          fakeScrollChild.style = 'height: 5px; width: ' + document.querySelector('.el-table__header').clientWidth + 'px;';
          
          fakeScroll.appendChild(fakeScrollChild);
          var tableBody = document.querySelector('.el-table__body-wrapper');
          tableBody.parentNode.insertBefore(fakeScroll, tableBody);
      
          var observer = new MutationObserver(function (mutations) {
              fakeScrollChild.style = 'height: 5px; width: ' + document.querySelector('.el-table__header').clientWidth + 'px;';
          });
          observer.observe(tableBody, {attributes: true});
      
          document.querySelector('.el-table__body-wrapper').onscroll = function (e) {
              document.querySelector('#fake-scroll').scrollLeft = e.target.scrollLeft;
          };
      
          document.querySelector('#fake-scroll').onscroll = function (e) {
              document.querySelector('#fake-scroll').scrollLeft = document.querySelector('.el-table__body-wrapper').scrollLeft;
          }
        }
        
      });

  },
  computed: {

    canPurchase : function (){
      return (this.$store.state.g_recaptcha_response == null && !window.userData.env && window.userData.recaptcha.enabled == 1 ? false : true);
    },

    cartCount() {
      return this.tableData.length;
    },
    priceTotal() {
      let sum = 0;
      _.each(this.tableData, function (item) {
        sum += (item.price_total_raw * item.pcs_in_pack);
      });
      return '€ ' + sum.toFixed(2);
    },
    m3Total(){
      let sum = 0;
      _.each(this.tableData, function (item) {
        sum += (item.thickness * item.length * item.width * 0.000000001 * item.quantity);
      });
      return sum.toFixed(2);
    },
    comment: {
      get() {
        return this.$store.state.orderComment;
      },
      set(data) {
        this.$store.commit('setOrderComment', data);
      },
    },
    rightHeader() {
      return this.$store.getters.getRightHeader;
    },
    // orderReady() {
    //   return this.$store.state.orderReady;
    // },
  }
});
